import React from 'react';
import DOMPurify from 'dompurify';
import { Link } from 'react-router-dom';
import navigate from './navigate'; 
import Icon from './Icon';

const PoiCard = ({ poi, taxonomyData, distance }) => {
  const taxonomy = poi.field_tipologia_poi?.length > 0 ? taxonomyData[poi.field_tipologia_poi[0].target_id] : null;

  const handleNavigate = () => {
    if (poi.field_geolocalizzazione && poi.field_geolocalizzazione[0]) {
      const { lat, lng } = poi.field_geolocalizzazione[0];
      navigate(lat, lng);
    } else {
      console.error('Coordinate del POI non disponibili');
    }
  };

  return (
    <div className="poi-card d-flex align-items-start flex-grow-1">
      <div className="flex-shrink-0">
        <img src={poi.field_immagini[0].url} className="img-fluid rounded-circle" alt={poi.field_immagini[0].alt} style={{ width: '80px', height: '80px' }} />
        <p className="mt-2 text-start small" style={{ maxWidth: '80px' }}>
        <Icon name="near_me" className="align-bottom" />{distance ? distance : ' - '}
        </p>
      </div>
      <div className="flex-grow-1 ms-3">
        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center">
            {taxonomy && (
              <div className="poi-taxonomy" style={{color: '#000'}}>
                <span className="me-1 small" >{taxonomy.title || 'Titolo tassonomia non disponibile'}</span>
                {taxonomy.icon && (
                  <img
                    src={taxonomy.icon}
                    alt={taxonomy.title}
                    className="poi-taxonomy-icon"
                    style={{ width: '20px', height: '20px' }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <h5 className="card-title fw-bold text-start mt-2">{poi.title[0].value}</h5>
        <div className="card-text text-start" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(poi.field_descrizione_breve[0]?.value || '') }} />
        <div className="d-flex mt-3 justify-content-end">
          <Link to={`/poi/${poi.nid[0]?.value}`} className="btn bg-white border rounded-pill d-flex align-items-center justify-content-center shadow-sm me-2 w-100 w-md-50 w-xl-30">
            Vai alla scheda
          </Link>
          <button 
            className="btn bg-white border rounded-circle d-flex align-items-center justify-content-center shadow-sm ratio-1x1 p-2"
            onClick={handleNavigate}
          >
           <Icon name="directions" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PoiCard;